interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  const go = (page: number) => {
    if (page < 1 || page > total) return;
    onChange(page);
  };

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap mt-10">
      <button
        type="button"
        onClick={() => go(current - 1)}
        disabled={current === 1}
        className="px-3 md:px-4 py-2 rounded-md border border-background-300 text-sm font-body text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line mr-1"></i>上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => go(page)}
          className={`w-9 h-9 rounded-md text-sm font-body transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50 font-semibold"
              : "text-foreground-600 hover:bg-background-100 border border-transparent hover:border-background-300"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => go(current + 1)}
        disabled={current === total}
        className="px-3 md:px-4 py-2 rounded-md border border-background-300 text-sm font-body text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页<i className="ri-arrow-right-s-line ml-1"></i>
      </button>
    </div>
  );
}